import React from "react";
import styled from "styled-components";
import type { ITheme } from "../../Themes/ThemeTypes";
import { ThemeColorEnum } from "../../Themes/ThemeEnums";
import { themeColor } from "../../Themes/ThemeFunctions";

const Page = styled.div<{ theme: ITheme; $background?: ThemeColorEnum }>`
  min-height: 100%;
  width: 100%;
  ${(props) =>
    props.$background !== undefined
      ? `background: ${themeColor(props.$background, props.theme)};`
      : ""}
`;

const Stack = styled.div<{ theme: ITheme; $maxWidth: number; $gap: number }>`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.$gap}px;
  padding: 24px 16px;
  max-width: ${(props) => props.$maxWidth}px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: ${(props) => props.theme.base.responsive.mobile}px) {
    padding: 16px 8px;
    gap: ${(props) => Math.min(props.$gap, 16)}px;
  }
`;

interface PageLayoutProps {
  children: React.ReactNode;
  maxWidth?: number;
  gap?: number;
  background?: ThemeColorEnum;
}

const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  maxWidth = 1080,
  gap = 24,
  background,
}) => (
  <Page $background={background}>
    <Stack $maxWidth={maxWidth} $gap={gap}>
      {children}
    </Stack>
  </Page>
);

export default PageLayout;
